var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48926 7.39782C9.48926 5.89448 10.708 4.67578 12.2113 4.67578C13.7146 4.67578 14.9333 5.89448 14.9333 7.39782C14.9333 8.39583 14.3962 9.2684 13.5954 9.74225C12.9052 10.1505 12.2113 10.7698 12.2113 11.5716V13.3863",
    stroke: "#1BA397",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2115 19.1923C13.0133 19.1923 13.6633 18.5424 13.6633 17.7406C13.6633 16.9388 13.0133 16.2888 12.2115 16.2888C11.4097 16.2888 10.7598 16.9388 10.7598 17.7406C10.7598 18.5424 11.4097 19.1923 12.2115 19.1923Z",
    fill: "#1BA397"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2112 1.67063C10.341 1.67063 8.58901 2.17041 7.07994 3.04335C6.83864 3.18294 6.52987 3.10048 6.39029 2.85918C6.25071 2.61788 6.33316 2.30911 6.57446 2.16953C8.23305 1.21009 10.1588 0.661133 12.2112 0.661133C18.4369 0.661133 23.4839 5.70809 23.4839 11.9338C23.4839 18.1595 18.4369 23.2065 12.2112 23.2065C5.98543 23.2065 0.938477 18.1595 0.938477 11.9338C0.938477 9.88146 1.48743 7.9557 2.44687 6.29712C2.58645 6.05582 2.89522 5.97336 3.13652 6.11295C3.37782 6.25253 3.46028 6.5613 3.3207 6.8026C2.44775 8.31167 1.94797 10.0637 1.94797 11.9338C1.94797 17.602 6.54297 22.197 12.2112 22.197C17.8793 22.197 22.4744 17.602 22.4744 11.9338C22.4744 6.26562 17.8793 1.67063 12.2112 1.67063Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQues);
export default __webpack_public_path__ + "static/media/ques.7115f6d9deb8866efdfe038756e4cf35.svg";
export { ForwardRef as ReactComponent };